export const environment = {
    baseURL: 'https://spectacularseminars.com/SeminarAdmin/api/',
    imageBaseURL: 'https://spectacularseminars.com/SeminarAdmin/uploads/'
}